/**
 * IdeaComments Styles
 * Extracted per Cursor Rules (<300 lines per file)
 */

import { StyleSheet } from 'react-native';
import { color, text, space, radius, icon, touch } from '../../../../shared/tokens/mobile';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  loadingContainer: {
    padding: space.xl,
    alignItems: 'center',
  },
  
  // Input
  inputContainer: {
    backgroundColor: color.surface,
    borderRadius: radius.lg,
    borderWidth: 1,
    borderColor: color.border,
    marginBottom: space.md,
    overflow: 'hidden',
  },
  replyingBanner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: space.md,
    paddingVertical: space.xs,
    backgroundColor: color.primaryLight,
  },
  replyingText: {
    fontSize: text.caption.fontSize,
    color: color.primary,
    fontWeight: '500',
  },
  inputRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    padding: space.sm,
    gap: space.sm,
  },
  input: {
    flex: 1,
    fontSize: text.body.fontSize,
    color: color.textPrimary,
    maxHeight: 100,
    paddingVertical: space.sm,
    paddingHorizontal: space.sm,
  },
  submitButton: {
    width: touch.minimum,
    height: touch.minimum,
    borderRadius: radius.full,
    backgroundColor: color.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  submitButtonDisabled: {
    backgroundColor: color.disabled,
  },
  
  // Empty state
  emptyContainer: {
    alignItems: 'center',
    paddingVertical: space.xl,
  },
  emptyText: {
    fontSize: text.body.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.textSecondary,
    marginTop: space.sm,
  },
  emptySubtext: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
    marginTop: space.xs,
  },
  
  // Comments list
  commentsList: {
    gap: space.md,
  },
  
  // Comment item
  commentContainer: {
    backgroundColor: color.surface,
    borderRadius: radius.md,
    padding: space.md,
    borderWidth: 1,
    borderColor: color.border,
  },
  replyContainer: {
    marginLeft: space.lg,
    marginTop: space.sm,
    backgroundColor: color.backgroundSecondary,
    borderColor: color.divider,
  },
  commentHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.sm,
    marginBottom: space.sm,
  },
  avatar: {
    width: 28,
    height: 28,
    borderRadius: 14,
    backgroundColor: color.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarText: {
    fontSize: 12,
    fontWeight: '600',
    color: color.surface,
  },
  commentMeta: {
    flex: 1,
  },
  authorName: {
    fontSize: text.caption.fontSize,
    fontWeight: '600',
    color: color.textPrimary,
  },
  timeAgo: {
    fontSize: 11,
    color: color.textMuted,
  },
  commentContent: {
    fontSize: text.body.fontSize,
    lineHeight: text.body.lineHeight,
    color: color.textPrimary,
  },
  commentActions: {
    flexDirection: 'row',
    marginTop: space.sm,
  },
  replyButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: space.xs,
    paddingHorizontal: space.sm,
    borderRadius: radius.sm,
  },
  replyButtonActive: {
    backgroundColor: color.primaryLight,
  },
  replyButtonText: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
  },
  replyButtonTextActive: {
    color: color.primary,
  },
  repliesContainer: {
    marginTop: space.sm,
  },
});

